import {View, type ViewProps} from 'react-native'
import {type PathProps} from 'react-native-svg'

import {Logo} from '#/view/icons/Logo'
import {Logotype} from '#/view/icons/Logotype'
import {atoms as a, useTheme} from '#/alf'

/**
 * Lucide grape mark + GRAPEVYNE wordmark row.
 */
export function LogomarkWithType({
  fill,
  width = 136,
  style,
  ...rest
}: {
  fill?: PathProps['fill']
  width?: number
} & Omit<ViewProps, 'children'>) {
  const t = useTheme()
  const color = fill || t.atoms.text.color
  const w = Number(width)

  return (
    <View style={[a.flex_row, a.align_center, a.gap_sm, style]} {...rest}>
      <Logo allowVariants={false} width={Math.round(w * 0.22)} fill={color} />
      <Logotype width={Math.round(w * 0.75)} fill={color} />
    </View>
  )
}
